import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import ActionsDropdown_vue_vue_type_script_setup_true_lang_default from "./ActionsDropdown.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                    */
//#region src/components/ActionsDropdown.vue
var ActionsDropdown_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ActionsDropdown_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-e2c3bd19"]]);
//#endregion
export { ActionsDropdown_default as default };

//# sourceMappingURL=ActionsDropdown.vue.js.map